// @flow
import React, { Component } from 'react';
import type { Node } from 'react';
import AppBar from '@material-ui/core/AppBar';
import withModal from 'packages/modal';
import withNotifications from 'packages/notifications';
import {
  Container,
  ToolbarStyled,
  LinkStyled,
  MainWrap,
  IcoLogoNovemberfiveStyled,
} from './Page.styled';

type Props = {
  children: Node,
};

class Page extends Component<Props> {
  render() {
    const { children } = this.props;

    return <Container>{children}</Container>;
  }
}

export default withNotifications(withModal(Page));



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Page/Page.js